import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";

const UserReviewScreen = loadable(() => import("./UserReviewScreen"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <UserReviewScreen {...props} />
  </ErrorBoundary>
);
